import axios from "axios";
import { API_URL, SELECT_MAX_RESULTS } from "./index";
class FilmService {
    filter = (titlePattern) => {
        const url = API_URL.film("find-by-title");
        return axios.get(url, {
            params: {
                titlePattern,
                maxResults: SELECT_MAX_RESULTS,
            },
        });
    };
    searchReleases = (params) => {
        const url = API_URL.filmRelease("find-by-criteria");
        return axios
            .get(url, {
                params: {
                    ...params,
                },
            })
            .then((response) => response.data);
    };
}

export default new FilmService();
